import React from 'react'

import type { DatePickerProps } from 'antd'
import { DatePicker as AntDatePicker, Form } from 'antd'
import type { DatePickRef } from 'antd/lib/date-picker/generatePicker/interface'
import moment from 'moment'

import { FORMAT_DATE } from 'utils/constants'
import useAccountClosingStore from 'views/InventoryControl/ClosingProcessSetting/stores/accountClosingStore'

type Props = DatePickerProps &
  TooltipInputProps & {
    lockDate?: boolean
  }
const DatePicker = (
  {
    errorMessage: _e,
    showErrorMessage: _m,
    className,
    disabled,
    lockDate = true,
    ...props
  }: Props,
  ref: DatePickRef<moment.Moment>,
): JSX.Element => {
  // const isClosed = useAccountClosingStore((state) => state.isClosed)
  const closedDate = useAccountClosingStore((state) => state.closedDate)
  const form = Form.useFormInstance()
  const formName = Form.useWatch('form_name', form)

  const isFieldDisabled = disabled
  // if (isClosed && lockDate) {
  //   isFieldDisabled = true // set field always disabled
  // }
  return (
    <AntDatePicker
      ref={ref}
      allowClear
      format={FORMAT_DATE}
      className={`w-full ${className}`}
      disabled={isFieldDisabled}
      disabledDate={(date) =>
        date.format(FORMAT_DATE) <= closedDate?.format(FORMAT_DATE) &&
        lockDate &&
        formName !== 'filterForm'
      }
      {...props}
      dateRender={(current) => {
        const isToday = current.isSame(moment(), 'day')
        return (
          <div
            className={`ant-picker-cell-inner ${
              isToday ? 'ant-picker-cell-japan-today' : ''
            }`}
          >
            {current.date()}
          </div>
        )
      }}
    />
  )
}

export default React.forwardRef(DatePicker)
